import { Megaphone, FileText, Send, Users2, Sparkles } from 'lucide-react';
import styles from './marketing.module.css';

const TOOLS = [
  { icon: FileText, title: 'תוכן ובלוג', body: 'פוסטים, מדריכים, חומרים שמושכים לידים. בעתיד: ספריית תוכן + מערכת תיוג.', external: 'https://app.notion.so', extLabel: 'Notion' },
  { icon: Send, title: 'קמפיינים', body: 'מעקב קמפיינים מ-Meta + Google + LinkedIn עם ייחוס ללידים.', external: 'https://business.facebook.com/adsmanager', extLabel: 'Meta Ads' },
  { icon: Users2, title: 'סושיאל', body: 'תזמון פוסטים ב-Instagram, LinkedIn, Facebook.', external: 'https://buffer.com', extLabel: 'Buffer' },
  { icon: Sparkles, title: 'ניוזלטר', body: 'רשימות תפוצה, פילוח, שליחות אוטומטיות.', external: 'https://brevo.com', extLabel: 'Brevo' },
];

export function MarketingPage() {
  return (
    <div className={styles.page}>
      <header className={styles.head}>
        <div>
          <h1>שיווק</h1>
          <p className={styles.sub}>מרכז השיווק של FocusMode. V1 מקשר לכלים חיצוניים; מודולים פנימיים יורחבו לפי צורך עסקי (M-P26).</p>
        </div>
        <Megaphone size={32} className={styles.headIcon} aria-hidden="true" />
      </header>

      <div className={styles.grid}>
        {TOOLS.map(({ icon: Icon, title, body, external, extLabel }) => (
          <div key={title} className={styles.card}>
            <div className={styles.cardHead}>
              <Icon size={20} aria-hidden="true" />
              <h3>{title}</h3>
            </div>
            <p className={styles.cardBody}>{body}</p>
            <a href={external} target="_blank" rel="noreferrer noopener" className={styles.btnSecondary}>
              פתח ב{extLabel}
            </a>
          </div>
        ))}
      </div>

      <p className={styles.notice}>
        ⓘ הפעלת מודולים פנימיים (ספריית תוכן · קמפיינים · ניוזלטר) תתבצע ב-M-P26 לפי הצורך.
        ראה <code dir="ltr">docs/ultraplan/marketing/01-overview.md</code>.
      </p>
    </div>
  );
}
